import { IconProps } from ".";

export const CalendarIcon: React.FC<IconProps> = (props) => {
  return (
    <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g id="calendar">
        <path
          id="Vector"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.33333 0.833008C5.60948 0.833008 5.83333 1.05687 5.83333 1.33301V2.16634H10.1667V1.33301C10.1667 1.05687 10.3905 0.833008 10.6667 0.833008C10.9428 0.833008 11.1667 1.05687 11.1667 1.33301V2.16634H12.6667C13.6792 2.16634 14.5 2.98715 14.5 3.99967V13.333C14.5 14.3455 13.6792 15.1663 12.6667 15.1663H3.33333C2.32081 15.1663 1.5 14.3455 1.5 13.333V3.99967C1.5 2.98715 2.32081 2.16634 3.33333 2.16634H4.83333V1.33301C4.83333 1.05687 5.05719 0.833008 5.33333 0.833008ZM4.83333 3.16634H3.33333C2.8731 3.16634 2.5 3.53944 2.5 3.99967V6.16634H13.5V3.99967C13.5 3.53944 13.1269 3.16634 12.6667 3.16634H11.1667V3.99967C11.1667 4.27582 10.9428 4.49967 10.6667 4.49967C10.3905 4.49967 10.1667 4.27582 10.1667 3.99967V3.16634H5.83333V3.99967C5.83333 4.27582 5.60948 4.49967 5.33333 4.49967C5.05719 4.49967 4.83333 4.27582 4.83333 3.99967V3.16634ZM13.5 7.16634H2.5V13.333C2.5 13.7932 2.8731 14.1663 3.33333 14.1663H12.6667C13.1269 14.1663 13.5 13.7932 13.5 13.333V7.16634Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};
